import useWindowSize from "./useWindowSize";

const useMediaQuery = () => {
  let [width] = useWindowSize();

  let mediaQeury;
  if (width >= 1200) {
    mediaQeury = "xl";
  } else if (width >= 992) {
    mediaQeury = "lg";
  } else if (width >= 768) {
    mediaQeury = "md";
  } else if (width >= 576) {
    mediaQeury = "sm";
  } else {
    mediaQeury = "xm";
  }

  return mediaQeury;
};

export default useMediaQuery;
